import { CallbackSaga, createGeneralCall } from '@altermaind/core/requests-status-management';
import { IS_MOCK_ENABLED } from '@/_shared/constants/mock';
import { GenericPost } from '@/_shared/types';
import { getCurrentOrganization } from '@/core/state/selectors';
import { API_ORGANIZATIONS_ORGANIZATIONID_DELEGATIONS_ASSIGNEES_USERID_ACTIVATION_EMAIL_PATH_KEY } from '@/swagger/constants/slash-keys';
import {
  API_POST_DELEGATE_ACTIVATION_EMAIL,
  KEY_POST_DELEGATE_ACTIVATION_EMAIL,
} from '../constants';
import { MOCK_RESPONSE_POST_DELEGATE_ACTIVATION_EMAIL } from '../mocks';

type RequestPostDelegateActionvationEmail = GenericPost<
  typeof API_ORGANIZATIONS_ORGANIZATIONID_DELEGATIONS_ASSIGNEES_USERID_ACTIVATION_EMAIL_PATH_KEY
>['request']['path'];

export type CallParamsPostDelegateActionvationEmail = Omit<
  RequestPostDelegateActionvationEmail,
  'organizationId'
> & {
  successSaga?: CallbackSaga;
  errorSaga?: CallbackSaga;
};

type CallResponsePostDelegateActionvationEmail = unknown;

type CallErrorPostDelegateActionvationEmail = {
  message: string;
  code: number;
};

type CallSelectorsPostDelegateActionvationEmail = unknown;

const responseMapper = () => ({
  status: 'OK',
});

export const postDelegateActivationEmailCall = createGeneralCall<
  CallParamsPostDelegateActionvationEmail,
  CallResponsePostDelegateActionvationEmail,
  CallErrorPostDelegateActionvationEmail,
  CallSelectorsPostDelegateActionvationEmail
>({
  id: KEY_POST_DELEGATE_ACTIVATION_EMAIL,
  url:
    ({ payload }) =>
    state => {
      const org = getCurrentOrganization(state);
      return API_POST_DELEGATE_ACTIVATION_EMAIL(org as unknown as string, payload.userId);
    },
  method: 'post',
  paramsSelector:
    ({ payload }) =>
    () => {
      return {
        ...payload,
      };
    },
  successMock: IS_MOCK_ENABLED() ? MOCK_RESPONSE_POST_DELEGATE_ACTIVATION_EMAIL : undefined,
  responseMapper,
  responseExtractor: null,
});
